import { MdKeyboardArrowDown } from 'react-icons/md'

import { Option } from 'src/types/form'

export interface SelectRebrandProps extends React.HTMLProps<HTMLSelectElement> {
  id: string
  options?: Option[]
}

// Note: Figma spec uses `#1D4321` for the dark green; nearest palette token is
// `forestDeep` (#08441B).
export const SelectRebrand = ({
  className = '',
  id,
  options,
  onChange,
  onBlur,
  value,
  disabled
}: SelectRebrandProps) => (
  <div
    className={`relative inline-flex items-center h-15 bg-forestDeep/8 border border-forestDeep/30 rounded-lg ${className}`}
  >
    <select
      id={id}
      name={id}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      className='appearance-none w-full h-full pl-4 pr-12 bg-transparent text-base font-body-rebrand text-forestDeep focus:outline-none cursor-pointer disabled:cursor-not-allowed'
    >
      {options?.map((opt, idx) => (
        <option
          key={`${opt.value}_${idx}`}
          value={opt.value}
          disabled={opt.disabled}
        >
          {opt.label}
        </option>
      ))}
    </select>
    <MdKeyboardArrowDown
      aria-hidden
      className='absolute right-4 w-6 h-6 text-forestDeep pointer-events-none'
    />
  </div>
)
